// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"d3358bda","386":"48591fd9","515":"8ded648d","540":"ec622a60","683":"1e61be22","843":"95c024f2"}[chunkId] + ".chunk.css";
};